export * from './src/angular/bootstrap-phoenix-plugin-wc';
export * from './src/angular/plugin-app-base-href';
export * from './src/angular/plugin-router-url';
export * from './src/angular/provide-phoenix-plugin';
export * from './src/angular/provide-phoenix-plugin-router';
export * from './src/angular/sync-phoenix-host-injector';
export * from './src/interfaces/IPluginComponent';
export * from './src/primeng/provide-phoenix-plugin-primeng';
export * from './src/report-trigger/report-trigger-execution';

